document.addEventListener('DOMContentLoaded', () => {
  const soldProductsSlider = document.querySelector(".sold-products-slider.slider");

  Object.assign(soldProductsSlider, {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.slider__pagination.sold-products',
      clickable: true,
    },
    navigation: {
      nextEl: '.right-arrow',
      prevEl: '.left-arrow',
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
        navigation: false
      },
      480: {
        slidesPerView: 1,
      },
      280: {
        slidesPerView: 1,
      },
    },
  });

  // Initialize the slider
  soldProductsSlider.initialize();

  // Function to toggle navigation and pagination visibility
  function toggleNavigationAndPagination() {
    const slides = soldProductsSlider.querySelectorAll('swiper-slide'); // Get slides
    const slidesPerView = soldProductsSlider.slidesPerView || 3; // Default to 3 if not explicitly set
    const totalSlides = slides.length;

    const showNavigation = totalSlides > slidesPerView;

    // Toggle navigation arrows visibility
    const nextArrow = document.querySelector('.right-arrow');
    const prevArrow = document.querySelector('.left-arrow');
    if (nextArrow && prevArrow) {
      nextArrow.style.display = showNavigation ? 'block' : 'none';
      prevArrow.style.display = showNavigation ? 'block' : 'none';
    }

    // Toggle pagination visibility
    const pagination = document.querySelector('.slider__pagination.sold-products');
    if (pagination) {
      pagination.style.display = showNavigation ? 'flex' : 'none';
    }
  }

  // Initial visibility check
  toggleNavigationAndPagination();

  // Recheck visibility when Swiper updates (e.g., after dynamic slides)
  soldProductsSlider.addEventListener('swiper.update', toggleNavigationAndPagination);
});
